module.exports = __webpack_public_path__ + "static/media/amdb.1f71e465.jpg";